export default {
  Exercise: {
    // vddung1
    Submit: 'Nộp bài',
    SaveDraft: 'Lưu nháp',
    Answer: 'Bài làm',
    Note: 'Ghi chú',
    StopMusic: 'Tắt nhạc',
    PlayMusic: 'Bật nhạc',
    BackQuestion: 'Câu trước',
    NextQuestion: 'Câu tiếp theo',
    Progress: 'Tiến độ',
    Reference: 'Khám phá',
    ExerciseDone: 'Đã làm',
    AllSubject: 'Tất cả môn học',
    AllExercises: 'Tất cả bài tập',
    ProgressDetail: '{finishedQuestion}/{totalQuestion} câu',
    EnterNote: 'Viết ghi chú của riêng bạn...',
    CopyAction: 'Sao chép',
    SelectFile: 'Chọn file',
    Save: 'Lưu',
    ExerciseRefer: 'Bài tập tham khảo',
    StudentSubmitContentPopup:
      'Còn <b> {unFinishedQuestion}/{totalQuestion} </b> câu chưa làm. Bạn có chắc muốn nộp bài không? <br/> Lưu ý: Chỉ được nộp một lần duy nhất.',
    PopoverContent:
      'Nhấn vào đây để xem tất cả câu hỏi, chọn nhanh câu cần xem.',
    Confirm: 'Đã hiểu',
    ShowAllQuestion: 'Xem tất cả câu hỏi',
    UploadOrClickFile: 'Kéo thả file bài làm vào đây hoặc nhấn để chọn file',
    MaxDataMemory: '* Dung lượng tối đa 10MB',
    MaxTenFile: '* Tối đa 10 file',
    StudentSubmitNotUploadFile:
      'Chưa có dữ liệu phiếu trả lời. Bạn có chắc muốn nộp bài không? <br/> Lưu ý: Chỉ được nộp một lần duy nhất.',
    StudentCompleteContentPopup:
      'Còn <b> {unFinishedQuestion}/{totalQuestion} </b> câu chưa làm. Bạn có chắc muốn kết thúc bài không? <br/> Lưu ý: Kết quả làm bài 2 lần gần nhất sẽ được lưu lại.',
    StudentCompleteNotUploadFile:
      'Chưa có dữ liệu phiếu trả lời. Bạn có chắc muốn kết thúc bài không? <br/> Lưu ý: Kết quả làm bài 2 lần gần nhất sẽ được lưu lại.',
    SubmitConfirm: 'Bạn có chắc muốn nộp bài không? <br/> Lưu ý: Chỉ được nộp một lần duy nhất.',
    CompeteConfirm: 'Bạn có chắc muốn kết thúc bài không? <br/> Lưu ý: Kết quả làm bài 2 lần gần nhất sẽ được lưu lại.',
    UploadExerciseDescription: 'Hướng dẫn xem tất cả câu hỏi, chọn câu cần xem làm bài tập từ phiếu tải lên',
    NoData: 'Không có dữ liệu',

    // nvhuy1
    YetSubmit: 'Chưa nộp',
    Expired: 'Đã hết hạn',
    Submitted: 'Đã nộp',
    Marked: 'Đã có bài chữa',
    HaveResult: 'Đã có kết quả',
    All: 'Tất cả',
    Search: 'Tìm kiếm bài tập',
    Class: 'Lớp ',
    Deadline: 'Hạn nộp ',
    SubmitDate: 'Ngày nộp ',
    SubmitProgress: 'Tiến độ ',
    SubjectName: 'Môn học ',
    TeacherName: 'Giáo viên ',
    AttachFile: 'Tài liệu tham khảo',
    Practive: 'Làm bài',
    QuestionTotal: '{total} câu',
    ExamTotal: '{total} đề',
    Remedy: 'Bài chữa',
    ViewDetail: 'Xem chi tiết',
    Download: 'Tải về máy',
    NoExercise: 'Chưa có bài tập',
    NoExerciseStore: 'Chưa có học liệu',
    NotFoundExercise: 'Không tìm thấy bài tập',
    TimeOut: 'Còn {diffDate} ngày',
    TimeOutHours: 'Còn {diffDate} giờ',
    EnterAnswer: 'Nhập câu trả lời',
    UnFinished: 'Còn <b> {unFinishedQuestion}/{totalQuestion} </b> câu chưa làm. Bạn có chắc muốn nộp bài không? <br>Lưu ý: Chỉ được nộp một lần duy nhất.', // Resource này thêm in đậm
    Finshed: 'Bạn có chắc muốn nộp bài không? <br>Lưu ý: Chỉ được nộp một lần duy nhất.',
    UnComplete: 'Còn <b> {unFinishedQuestion}/{totalQuestion} </b> câu chưa làm. Bạn có chắc muốn kết thúc bài không? <br>Lưu ý: Kết quả làm bài 2 lần gần nhất sẽ được lưu lại.',
    CompleteExercise: 'Bạn có chắc muốn kết thúc bài không? <br>Lưu ý: Kết quả làm bài 2 lần gần nhất sẽ được lưu lại.',
    PrativeExercise: 'Làm bài chỉ phục vụ mục đích tự tập luyện. Bạn không thể nộp bài cho giáo viên.',
    PractiveExerciseDraft: 'Làm lại bài tập từ đầu sẽ xóa toàn bộ kết quả làm bài trước đó',
    ConfirmReplayExercise: 'Bạn đang lưu nháp bài tập này. Tiếp tục làm bài hay làm lại từ đầu?',
    Understand: 'Đã hiểu',
    Cancel: 'Hủy',
    Again: 'Làm từ đầu',
    Replay: 'Làm lại',
    ChangeQuestion: 'Chuyển câu',
    UserManualBefore: 'Nhấn vào nút mũi tên hoặc sử dụng phím',
    UserManualAfter: 'trên bàn phím để chuyển câu.',
    Complete: 'Hoàn thành',
    Select: 'Chọn đáp án đúng',
    Fill: 'Điền từ vào chỗ trống',
    Essay: 'Tự luận',
    ManualUseNextBackDescription: 'Hướng dẫn sử dụng nút next back trong màn hình học sinh làm bài tự soạn',
    DontShowAgain: 'Không hiển thị lại',
    DescriptionDontShowAgain: 'Option có hiển thị lại thông báo làm bài với mục đích luyện tập hay không.',
    // bndung
    Correct: 'Đúng',
    False: 'Sai',
    NotDone: 'Chưa làm',
    Done: 'Đã làm',
    NeedReview: 'Cần xem lại',
    Doing: 'Đang làm',
    Reply: 'Trả lời',
    Result: 'Đáp án',
    TheAnswer: 'Lời giải',
    PractiveExercise: 'Luyện tập',
    TheQuestion: 'Đề bài',
    TheDocument: 'Tài liệu',
    TheSentence: 'Câu',
    TheSentenceNumber: 'Câu {number}',
    QuestionAndAnswer: 'Đề bài và lời giải',
    ViewDocument: 'Xem bài giảng',
    DoAgainWrongSentence: 'làm lại câu sai',

    // vvhung
    QuestionChoice: 'Câu trắc nhiệm',
    QuestionEssay: 'Câu tự luận',
    ListQuestion: 'Danh sách câu',
    AnswerWrited: 'Lời giải',

    ListExerciseDone: 'Danh sách bài đã làm',
    MultiChoice: 'Trắc nghiệm',
    ResultExercise: 'Kết quả bài tập',

    ExerciseDeleted: 'Giáo viên đã thu hồi bài tập này',
    Question: 'Câu ',
    CommentExercise: 'Nhận xét',

    // PBac
    StudentAnswer: 'Bài làm',
    TotalQuestion: '{total} câu',
    GradeAndSubject: 'Khối {grade} - Môn {subject}',
    PracticeCompleteConfirm: 'Bạn có chắc muốn hoàn thành không? <br/> Lưu ý: Kết quả làm bài 3 lần gần nhất sẽ được lưu lại.',
    PracticeCompleteContentPopup: 'Còn <b> {unFinishedQuestion}/{totalQuestion} </b> câu chưa làm. Bạn có chắc muốn kết thúc bài không? <br/> Lưu ý: Kết quả làm bài 3 lần gần nhất sẽ được lưu lại.',
    ViewResult: 'Xem bài đã làm',
    Subject: 'Môn: {subjectName}',
    Grade: 'Khối: {grade}',
    PrintFileNameThread: 'DEBAI - {title}',
    CorrectAnswer: 'Đáp án đúng: ',
    ChooseExerciseTheme: 'Chọn giao diện làm bài',
    ChooseOtherExerciseTheme: 'Chọn giao diện làm bài khác',
    DoExercise: 'Bắt đầu làm bài',
    CloseQuestion: 'Thu gọn câu hỏi',
    OpenQuestion: 'Mở rộng câu hỏi',
    CloseAnswer: 'Thu gọn câu trả lời',
    OpenAnswer: 'Mở rộng câu trả lời',
    ContinueDoExercise: 'Tiếp tục làm bài',
    Leave: 'Rời đi',
    LeaveDoExerciseMessage: 'Bạn có muốn tiếp tục làm bài tập không?',
    CongratFinnishAll: 'Chúc mừng bạn đã hoàn thành tất cả câu hỏi!',
    SubmitNow: 'Nộp bài ngay',
    OrCheckAgain: 'Hoặc kiểm tra lại bài làm',
    HaveQuestionLeft: 'Bạn còn {numberQuestion} câu chưa làm',
    ClickOnUndoneQuestion: 'Nhấn vào câu chưa làm để quay lại làm nốt nhé!',
    Or: 'Hoặc',
    SubmitOnceNotify: 'Lưu ý: Chỉ được nộp một lần duy nhất',
    CompleteNotify: 'Lưu ý: Hệ thống sẽ lưu lại 2 lần làm bài gần nhất',
    CorrectResult: 'Đáp án đúng',
    Game: 'Trò chơi',
    NextQuestionMessage: 'Bạn vừa làm xong câu {currentQuestion}. Mình cùng chuyển sang câu {nextQuestion} nhé!',
    LastQuestionMessage: 'Bạn vừa làm xong câu cuối cùng. Mình cùng soát lại bài nhé!',
    ViewRemedy: 'Xem bài chữa',
    SummaryResultMessage: 'Cùng xem lại <b>{wrongAnswers}/{totalAnswers}</b> câu trả lời chưa đúng và chọn <b>Làm lại</b> để nắm chắc kiến thức hơn nhé',
    RecommendContinue: 'Gợi ý tiếp tục học tập',
    DoneExerciseMessage: 'Chúc mừng bạn đã hoàn thành tất cả bài tập',
    DoneExerciseSubMessage: 'Cùng ôn luyện qua',
    ExerciseReference: 'bài tập tổng hợp',
    OrDiscoverMore: 'hoặc khám phá thêm',
    DiscoverMore: 'Cùng khám phá thêm',
    Library: 'học liệu',
    YouPlease: 'hấp dẫn khác bạn nhé!',
    SyntheticTitle: 'Bài tập tổng hợp',
    SyntheticSubtitle: 'Ôn luyện các kiến thức đã được học trong tháng',
    LibraryTitle: 'Học liệu',
    LibrarySubtitle: 'Kho bài giảng, bài tập chọn lọc cho bạn',
    YetSubmitTitle: 'Làm tiếp bài tập',
    YetSubmitSubtitle: 'Hoàn thành nốt các bài tập thầy cô giao',
    ContinueStudy: 'Tiếp tục học tập',
    ViewRefAttachment: 'Xem tài liệu',
    ChooseRefAttachment: 'Chọn bài giảng',
    Compensate: 'Sửa bài',
    NotAllowCompensateMessage: 'Thầy cô không cho phép sửa lại bài tập này',
    TeacherMessageTemplateFirst: 'Thầy/cô dặn dò',
    TeacherMessageTemplateSecond: '"{message}"',
    WaitingForResult: 'Đang chờ kết quả',

    // NVHUY1
    SubmitExamination: 'Bạn có chắc muốn nộp bài không?',
    SubmitExaminationUnFinish: 'Còn <b> {unFinishedQuestion}/{totalQuestion} </b> câu chưa làm. Bạn có chắc muốn nộp bài không?',
    ViewMore: 'Xem thêm',
    CompleteNow: 'Hoàn thành bài',
    // VHSOn
    Learning: 'Đang học',
    Care: 'Quan tâm',
    PercentCourseProgress: '{exercisePercent} %',
    FavouriteCourse: 'Học liệu yêu thích',
    SearchStorage: 'Tìm kiếm học liệu',
    AllSource: 'Tất cả các nguồn',
    AllStorageType: 'Tất cả loại học liệu',
    AllStatus: 'Tất cả trạng thái',
    FavouriteList: 'Danh sách yêu thích',
    SourceHocmai: 'HOCMAI.VN',
    SourceEmis: 'Cộng đồng giáo viên',
    SourceIGiaoDuc: 'Học liệu số BGD',
    SoureHanhTrangSo: 'NXB Giáo dục',
    SourceConTuHoc: 'Con Tự Học',
    GradeAndSubjectPractice: '{subjectName} - {grade}',
    CourseIsFree: 'Học thử',
    // pqhieu
    DidPracticeExercises: 'Danh sách các lần luyện tập',
    DownloadsToPc: 'Tải về máy',
    NumberPractice: 'Luyện tập lần {number}',
    DateDoExercise: 'Lúc {time} ngày {date}',
    ViewHint: 'Xem lời giải',
    // TTLONG
    Support: ' Hỗ trợ',
    PracticeOnline: 'Luyện tập online',
    DeleteNote: 'Bạn có chắc muốn xóa ghi chú này?',
    ChooseSubject: 'Chọn môn học để ôn luyện'
  },
  SubjectType: {
    Maths: 'TOAN',
    Literature: 'TIENGVIET',
    English: 'TIENGANH'
  },

  SelfLearning: {
    CourseOverview: 'Tổng quan khóa học',
    PracticeKnowledge: 'Ôn luyện kiến thức',
    PracticeExam: 'Luyện đề thi',
    ExamBank: 'Ngân hàng đề thi',
    QuestionBank: 'Ngân hàng câu hỏi',
    ReplyCorrect: 'Câu trả lời chính xác!',
    ReplyWrong: 'Câu trả lời chưa chính xác!',
    RegisterCourseRemember: 'Để xem lời giải chi tiết vui lòng đăng ký khóa học.',
    ViewDetailAnswer: 'Chọn xem Lời giải chi tiết để đọc giải thích và hiểu rõ hơn về đáp án nhé!',
    Skip: 'Bỏ qua',
    Examination: 'Kiểm tra',
    StudyRegistration: 'Đăng ký học',
    CompleteExercise: 'Bạn đã hoàn thành đề thi!',
    RelatedCourse: 'Khóa học liên quan',
    DetailAnswer: 'Lời giải chi tiết',
    TitleCommentResultGood: 'Chúc mừng bạn đã đạt kết quả tốt!',
    ContentCommentResultGood: 'Quá tuyệt vời! Tiếp tục luyện tập để giữ vững thành tích học tập ấn tượng này nhé!',
    TitleCommentResultAverage: 'Chúc mừng bạn đã hoàn thành bài!',
    ContentCommentResultAverage: 'Nỗ lực của bạn đã được ghi nhận! Đừng quên luyện tập thêm để nâng hạng thành tích học tập!',
    TitleCommentResultPoor: 'Bạn cần cố gắng hơn!',
    ContentCommentResultPoor: 'Chăm chỉ luyện tập thêm để đạt kết quả tốt hơn nhé!',
    TimeDoneExam: 'Thời gian hoàn thành bài thi',
    Correct: 'Đúng',
    Wrong: 'Sai',
    ChooseWayDoHomeWork: 'Chọn cách thức làm bài',
    CheckResultAfterEverySentence: 'Kiểm tra kết quả <br/>sau từng câu',
    KnownswerWhenCompleteTheSentence: 'Biết đáp án ngay <br/>khi hoàn thành câu',
    CheckResultAfterSubmit: 'Kiểm tra kết quả <br/>sau khi nộp bài',
    FocusHomeWorkAndSaveTime: 'Tập trung làm bài<br/>Tiết kiệm thời gian',
    DoSelfPractice: 'Làm bài tập tự luyện<br/>Nhận sao ngay!',
    Setup: 'Thiết lập'

  }

}
